<template>
    <div class="user my-camp-order camp-member-page">
        <div class="headerbg">
            <b-container class="d-flex align-items-center justify-content-between">
                <h1>{{ title }}</h1>
                <b-button variant="outline-secondary" size="sm" @click="logout">登出</b-button>
            </b-container>
        </div>
        <b-container fluid="xl">
            <b-row>
                <b-col cols="12" md="2" class="member-sidebar-col">
                    <nacUser></nacUser>
                </b-col>
                <b-col cols="12" md="10" class="member-content-col">
                    <b-card class="mb-3">
                        <template #header>
                            <span class="font-weight-bold">訂單總覽</span>
                        </template>
                        <div>
                            <b-row class="mb-3" align-v="center" align-h="end">
                                <b-col cols="12" md="5" lg="4">
                                    <b-input-group>
                                        <b-input-group-prepend is-text>
                                            <b-icon icon="search"></b-icon>
                                        </b-input-group-prepend>
                                        <b-form-input v-model="Search.keywords" placeholder="訂單編號 / 系列 / 營隊 / 梯次"></b-form-input>
                                    </b-input-group>
                                </b-col>
                            </b-row>
                            <!-- 桌機表格 -->
                            <div class="d-none d-md-block">
                            <b-table hover :items="items" :fields="fields" :tbody-tr-class="rowClass"
                                show-empty empty-text="目前沒有營隊訂單" class="camp-order-table camp-member-table">
                                <template #cell(OrderNo)="{ item }">
                                    <div class="font-weight-bold">{{ item.OrderNo }}</div>
                                    <div class="small text-muted">{{ item.Create | datefmt('YYYY-MM-DD HH:mm') }}</div>
                                </template>
                                <template #cell(OrderState)="{ item }">
                                    <b-badge :variant="orderStateVariant(item.OrderStateNum)">{{ item.OrderState }}</b-badge>
                                    <b-badge v-if="item.HasUnpaidSurcharge" variant="warning" pill class="ml-1">補收款待繳</b-badge>
                                    <b-badge v-if="item.HasPendingRefund" variant="info" pill class="ml-1">退費處理中</b-badge>
                                </template>
                                <template #cell(TotalPrice)="{ item }">
                                    {{ item.TotalPrice | money(0, 2) }}
                                </template>
                                <template #cell(tool)="{ item }">
                                    <b-button variant="link" @click="goDetail(item)"
                                        v-b-tooltip.hover title="查看訂單明細">
                                        <b-icon icon="eye-fill"></b-icon>
                                    </b-button>
                                </template>
                            </b-table>
                            </div>

                            <!-- 手機卡片 -->
                            <div class="d-md-none">
                                <div v-if="items.length === 0" class="text-center text-muted py-3">
                                    目前沒有營隊訂單
                                </div>
                                <div v-for="order in items" :key="order.Id" class="camp-order-row-card"
                                    :class="{ 'card-unpaid': isUnpaid(order) }" @click="goDetail(order)">
                                    <div class="d-flex flex-wrap align-items-start justify-content-between">
                                        <div>
                                            <div class="font-weight-bold">{{ order.OrderNo }}</div>
                                            <div class="small text-muted">{{ order.Create | datefmt('YYYY-MM-DD HH:mm') }}</div>
                                        </div>
                                        <div class="text-right">
                                            <b-badge :variant="orderStateVariant(order.OrderStateNum)">{{ order.OrderState }}</b-badge>
                                            <b-badge v-if="order.HasUnpaidSurcharge" variant="warning" pill class="d-inline-block mt-1">補收款待繳</b-badge>
                                            <b-badge v-if="order.HasPendingRefund" variant="info" pill class="d-inline-block mt-1">退費處理中</b-badge>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between mt-2">
                                        <span class="font-weight-bold">{{ order.TotalPrice | money(0, 2) }}</span>
                                        <b-icon icon="chevron-right" class="text-muted"></b-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <template v-if="rows > 0">
                            <div class="overflow-auto mt-3">
                                <b-pagination align="center" v-model="Param.Paging.pageNumber" :total-rows="rows"
                                    :per-page="Param.Paging.pageSize"></b-pagination>
                            </div>
                        </template>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import nacUser from '@/components/nacUser.vue';
import { apiCampOrderList } from '@/api/API.js';
import { campOrderStateVariant } from '@/utils/campEnums.js';

export default {
    name: 'MyCampOrder',
    components: { nacUser },
    data() {
        return {
            title: '訂單總覽',
            items: [],
            rows: 0,
            fields: [
                { key: 'OrderNo', label: '訂單編號', thStyle: { width: '34%' } },
                { key: 'OrderState', label: '訂單狀態', thStyle: { width: '22%' } },
                { key: 'TotalPrice', label: '應付金額', thStyle: { width: '22%' } },
                { key: 'tool', label: '操作', thStyle: { width: '22%' } },
            ],
            Param: {
                Paging: { pageNumber: 1, pageSize: 10 },
                Search: { keywords: '' },
            },
            Search: { keywords: '' },
        };
    },
    watch: {
        'Param.Paging.pageNumber'() {
            this.GetList();
        },
        'Search.keywords'(newVal) {
            this.Param.Search.keywords = encodeURI(newVal || '');
            this.Param.Paging.pageNumber = 1;
            this.GetList();
        },
    },
    mounted() {
        if (this.IsNull(this._sessionData('TokenID')) == '') {
            alert('尚未登入');
            this._go('/');
            return;
        }
        this.GetList();
    },
    methods: {
        logout() {
            const data1 = this._storeData('Header_form1');
            if (this.IsNull(data1) !== '') {
                data1.text = '學員登入';
            }
            this._sessionData('NewToken', '');
            this._sessionData('TokenID', '');
            this._sessionData('campCartCachedCount', '');
            this._sessionData('courseCartCachedCount', '');
            this._go('/');
        },
        GetList() {
            this.loadSet.show = true;
            apiCampOrderList(this.Param)
                .then((res) => {
                    const paging = JSON.parse(res.headers['list-header']).Paging;
                    this.rows = paging.totalCount;
                    this.items = res.data;
                    this.loadSet.show = false;
                })
                .catch(() => {
                    this.loadSet.show = false;
                });
        },
        goDetail(order) {
            if (!order || !order.Id) return;
            this.$router.push({ path: '/campOrderDetail', query: { orderId: order.Id } });
        },
        orderStateVariant(statusNum) {
            return campOrderStateVariant(statusNum);
        },
        isUnpaid(order) {
            return order && order.OrderStateNum === 10;
        },
        rowClass(item) {
            return item && this.isUnpaid(item) ? 'payment-unpaid' : '';
        },
    },
};
</script>
<style>
.my-camp-order .camp-order-row-card {
    padding: 12px;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    margin-bottom: 8px;
    background: #fff;
    cursor: pointer;
}

.my-camp-order .camp-order-table td {
    vertical-align: middle;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}

.my-camp-order .camp-order-table td:first-child > div {
    white-space: nowrap;
}

.my-camp-order .camp-order-table .payment-unpaid td {
    background-color: #fff8e1;
}

.my-camp-order .camp-order-row-card.card-unpaid {
    background-color: #fff8e1;
}
</style>
